// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#AdminUserRagStructure .base-card {
  border-radius: 8px;
}
#AdminUserRagStructure .middle-button {
  max-width: 15%;
}
#AdminUserRagStructure .long-button {
  max-width: 20%;
}
#AdminUserRagStructure .vlong-button {
  max-width: 25%;
}
#AdminUserRagStructure .addmergin {
  margin-top: 32px;
  padding-bottom: 32px;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/AdminUserRagStructure.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AAGI;EACI,cAAA;AADR;AAGI;EACI,cAAA;AADR;AAGI;EACI,cAAA;AADR;AAII;EACI,gBAAA;EACA,oBAAA;AAFR","sourcesContent":["#AdminUserRagStructure{\r\n    .base-card{\r\n        border-radius: 8px;\r\n    }\r\n\r\n    .middle-button{\r\n        max-width: 15%\r\n    }\r\n    .long-button{\r\n        max-width: 20%\r\n    }\r\n    .vlong-button{\r\n        max-width: 25%\r\n    }\r\n\r\n    .addmergin{\r\n        margin-top: 32px;\r\n        padding-bottom: 32px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
